(function () {
  function initGallery(root) {
    var main = root.querySelector('[data-is-main-image]');
    var count = root.querySelector('[data-is-gallery-count]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-is-thumb], [data-is-thumbnail]'));
    var previous = root.querySelector('[data-is-gallery-previous]');
    var next = root.querySelector('[data-is-gallery-next]');
    if (!main || !thumbs.length) return;

    function activate(index) {
      var normalizedIndex = (index + thumbs.length) % thumbs.length;
      var thumb = thumbs[normalizedIndex];
      var src = thumb.getAttribute('data-src');
      var alt = thumb.getAttribute('data-alt') || '';
      var productShot = thumb.getAttribute('data-product-shot') === 'true';
      if (!src) return;
      main.src = src;
      main.alt = alt;
      main.setAttribute('data-product-shot', productShot ? 'true' : 'false');
      thumbs.forEach(function (item) {
        var selected = item === thumb;
        item.classList.toggle('is-active', selected);
        item.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
      if (count) count.textContent = (normalizedIndex + 1) + ' / ' + thumbs.length;
      thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }

    thumbs.forEach(function (thumb, index) { thumb.addEventListener('click', function () { activate(index); }); });
    if (previous) previous.addEventListener('click', function () { activate(thumbs.findIndex(function (thumb) { return thumb.classList.contains('is-active'); }) - 1); });
    if (next) next.addEventListener('click', function () { activate(thumbs.findIndex(function (thumb) { return thumb.classList.contains('is-active'); }) + 1); });
  }

  function initVariantForm(root) {
    var dataNode = root.querySelector('[data-is-variants-json], [data-is-variants]');
    var form = root.querySelector('[data-is-product-form], .is-product-form');
    if (!dataNode || !form) return;

    var variants;
    try { variants = JSON.parse(dataNode.textContent); } catch (error) { return; }

    var selectors = Array.prototype.slice.call(form.querySelectorAll('[data-is-variant-option]'));
    var idInput = form.querySelector('[name="id"]');
    var atc = form.querySelector('[data-is-main-atc], [data-is-atc]');
    var price = root.querySelector('[data-is-price]');
    var comparePrice = root.querySelector('[data-is-compare-price]');
    var discountBadge = root.querySelector('[data-is-discount-badge]');
    var currency = root.getAttribute('data-currency') || 'USD';

    form.querySelectorAll('[data-is-swatch]').forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        var select = form.querySelector('#' + swatch.getAttribute('data-select-id'));
        var group = swatch.closest('[data-is-swatches]');
        var valueLabel = form.querySelector('#' + swatch.getAttribute('data-label-id'));
        if (!select || swatch.disabled) return;
        select.value = swatch.getAttribute('data-value');
        if (group) group.querySelectorAll('[data-is-swatch]').forEach(function (item) {
          var selected = item === swatch;
          item.classList.toggle('is-selected', selected);
          item.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
        if (valueLabel) valueLabel.textContent = swatch.getAttribute('data-value');
        select.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    function updateVariant() {
      var selected = selectors.map(function (selector) { return selector.value; });
      var variant = variants.find(function (item) {
        return item.options.every(function (option, index) { return option === selected[index]; });
      });
      if (!variant) return;
      if (idInput) idInput.value = variant.id;
      if (atc) {
        atc.disabled = !variant.available;
        var label = atc.querySelector('[data-is-atc-label]');
        if (label) label.textContent = variant.available ? 'Add to cart' : 'Unavailable';
        else atc.textContent = variant.available ? 'Add to cart' : 'Unavailable';
      }
      if (price && typeof variant.price === 'number') {
        price.textContent = new Intl.NumberFormat('en-US', { style: 'currency', currency: currency }).format(variant.price / 100);
      }
      var compareValue = Number(variant.compare_at_price || 0);
      var hasDiscount = compareValue > Number(variant.price || 0);
      if (comparePrice) {
        comparePrice.hidden = !hasDiscount;
        comparePrice.textContent = hasDiscount ? new Intl.NumberFormat('en-US', { style: 'currency', currency: currency }).format(compareValue / 100) : '';
      }
      if (discountBadge) {
        discountBadge.hidden = !hasDiscount;
        discountBadge.textContent = hasDiscount ? Math.round(((compareValue - variant.price) / compareValue) * 100) + '% off' : '';
      }
    }

    selectors.forEach(function (selector) { selector.addEventListener('change', updateVariant); });
  }

  function initSticky(root) {
    var mainButton = root.querySelector('[data-is-main-atc], [data-is-atc]');
    var sticky = document.querySelector('[data-is-sticky-atc]');
    var stickyButton = sticky && sticky.querySelector('[data-is-sticky-button]');
    if (!mainButton || !sticky || !stickyButton) return;
    sticky.hidden = false;

    var observer = new IntersectionObserver(function (entries) {
      sticky.classList.toggle('is-visible', !entries[0].isIntersecting);
    }, { threshold: 0 });
    observer.observe(mainButton);

    stickyButton.addEventListener('click', function () { mainButton.click(); });
  }

  function initRecommendations() {
    document.querySelectorAll('product-recommendations[data-url]').forEach(function (element) {
      if (element.getAttribute('data-loaded') === 'true') return;
      fetch(element.getAttribute('data-url'))
        .then(function (response) { return response.text(); })
        .then(function (text) {
          var html = new DOMParser().parseFromString(text, 'text/html');
          var incoming = html.querySelector('product-recommendations');
          if (incoming && incoming.innerHTML.trim()) element.innerHTML = incoming.innerHTML;
          element.setAttribute('data-loaded', 'true');
        })
        .catch(function () { element.setAttribute('data-loaded', 'error'); });
    });
  }

  function initPreviewChoices() {
    document.querySelectorAll('[data-is-preview-choice]').forEach(function (button) {
      button.addEventListener('click', function () {
        var group = button.closest('.is-choice-row');
        if (!group) return;
        group.querySelectorAll('[data-is-preview-choice]').forEach(function (item) { item.classList.remove('is-selected'); });
        button.classList.add('is-selected');
      });
    });
  }

  function initPreviewSwatches() {
    document.querySelectorAll('[data-is-preview-swatch]').forEach(function (button) {
      button.addEventListener('click', function () {
        if (button.disabled) return;
        var group = button.closest('[data-is-preview-swatches]');
        var label = document.querySelector('[data-is-preview-color]');
        if (!group) return;
        group.querySelectorAll('[data-is-preview-swatch]').forEach(function (item) {
          var selected = item === button;
          item.classList.toggle('is-selected', selected);
          item.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
        if (label) label.textContent = button.getAttribute('data-value');
      });
    });
  }

  function initPreviewCardButtons() {
    document.querySelectorAll('[data-is-preview-card-atc]').forEach(function (button) {
      button.addEventListener('click', function () {
        button.querySelector('span:first-child').textContent = 'Added';
        button.classList.add('is-added');
      });
    });
  }

  function initPreviewCart() {
    var drawer = document.querySelector('[data-is-preview-cart]');
    var backdrop = document.querySelector('[data-is-preview-cart-backdrop]');
    var close = drawer && drawer.querySelector('[data-is-preview-cart-close]');
    if (!drawer || !backdrop) return;

    function setOpen(open) {
      drawer.classList.toggle('is-open', open);
      drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
      backdrop.hidden = !open;
      document.body.classList.toggle('is-cart-open', open);
    }

    document.querySelectorAll('[data-is-main-atc]').forEach(function (button) {
      button.addEventListener('click', function () { setOpen(true); });
    });
    if (close) close.addEventListener('click', function () { setOpen(false); });
    backdrop.addEventListener('click', function () { setOpen(false); });
    document.addEventListener('keydown', function (event) { if (event.key === 'Escape') setOpen(false); });
  }

  function boot() {
    document.querySelectorAll('[data-is-product-root]').forEach(function (root) {
      initGallery(root);
      initVariantForm(root);
      initSticky(root);
    });
    initRecommendations();
    initPreviewChoices();
    initPreviewSwatches();
    initPreviewCardButtons();
    initPreviewCart();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
